import controller from './otp-dialog.controller';

export default {
  controller,
  template: require('./otp-dialog.html')
};


// WEBPACK FOOTER //
// src/app/no-auth/components/otp-dialog/otp-dialog.component.ts